import { render, staticRenderFns } from "./material-detail.vue?vue&type=template&id=1eb274b9&scoped=true&"
import script from "./material-detail.vue?vue&type=script&lang=ts&"
export * from "./material-detail.vue?vue&type=script&lang=ts&"
import style0 from "./material-detail.vue?vue&type=style&index=0&id=1eb274b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb274b9",
  null
  
)

export default component.exports